/**
 * Centralized application configuration
 * All environment-based and general app configs are defined here
 */

export const CONFIGS = {
  app: {
    name: process.env.NEXT_PUBLIC_APP_NAME || "Rawej",
    displayName: {
      en: "Rawej",
      de: "Rawej",
      fr: "Rawej",
      ckb: "ڕاۆێژ",
      kmr: "Rawej",
      fa: "ڕاۆێژ",
    } as const,
    url: process.env.NEXT_PUBLIC_APP_URL,
    apiUrl: process.env.NEXT_PUBLIC_API_URL,
    remoteApiUrl: process.env.NEXT_PUBLIC_REMOTE_API_URL,
  },

  // Internationalization Configuration
  i18n: {
    defaultLanguage: (process.env.NEXT_PUBLIC_FALLBACK_LANGUAGE || "en") as "en" | "de" | "fr" | "ckb" | "kmr" | "fa",
    supportedLanguages: ["en", "de", "fr", "ckb", "kmr", "fa"] as const,
  },

  // Public contact details for the /contact page; unset ones are hidden
  contact: {
    email: process.env.NEXT_PUBLIC_CONTACT_EMAIL || "",
    phone: process.env.NEXT_PUBLIC_CONTACT_PHONE || "",
    address: process.env.NEXT_PUBLIC_CONTACT_ADDRESS || "",
    whatsapp: process.env.NEXT_PUBLIC_CONTACT_WHATSAPP || "+989906199197",
    telegram: process.env.NEXT_PUBLIC_CONTACT_TELEGRAM || "+989906199197",
    bale: process.env.NEXT_PUBLIC_CONTACT_BALE || "+989906199197",
  },

  // Routes Configuration
  routes: {
    dashboard: process.env.NEXT_PUBLIC_DASHBOARD_URL || "/dashboard",
  },

  // API Configuration
  enableMockFallback: process.env.ENABLE_MOCK_FALLBACK === "true",
  remoteApi: {
    url: process.env.REMOTE_API_URL,
    user: process.env.REMOTE_API_USER,
    password: process.env.REMOTE_API_PASSWORD,
  },
  disableSslVerification: process.env.NODE_ENV === "development" || process.env.APP_ENV === "development",


  // Cache Configuration
  apiCacheRevalidate: parseInt(process.env.API_CACHE_REVALIDATE || "300", 10),
  cdnMaxAge: process.env.CDN_MAX_AGE || "300",
  cdnStaleWhileRevalidate: process.env.CDN_STALE_WHILE_REVALIDATE || "600",

  // ISR (Incremental Static Regeneration) Configuration
  isr: {
    revalidateTime: parseInt(process.env.ISR_REVALIDATE || "60", 10),
  },

  // Pagination Configuration
  pagination: {
    defaultPage: 1,
    defaultLimit: 10,
    minLimit: 1,
    maxLimit: 100,
    doctorsPerPage: 9, // For home page
  },

  // Analytics Configuration
  analytics: {
    gaMeasurementId: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
    gscVerificationCode: process.env.NEXT_PUBLIC_GSC_VERIFICATION_CODE,
  },

  // CORS Configuration
  allowedOrigins: (process.env.ALLOWED_ORIGINS || "").split(",").filter(Boolean),
} as const;

